<template>
    <footer class="footer">
        <div class="container">
            <div class="row" v-if="$route.name == 'New application'">
                <div class="col-auto">
                    <p
                        class="disclaimer google-title"
                    >Personal information on this form is collected under the authority of Section 11 of the Municipal Act, 2001 and the City of Mississauga Policy No. 06-03-02. The information will be used to process applications and in public notices to the community. Questions about this collection should be directed to the City of Mississauga, Supervisor, Film &amp; Television, 300 City Centre Drive, Mississauga ON L5B 3C1 Tel: 905-615-3200, ext. 6150. E-mail: film.office@mississauga.ca</p>
                </div>
            </div>
            <!--
            <div class="row">
                <div class="col-xs-12">&copy; City of Mississauga {{date}}</div>
            </div>
            -->
        </div>






        <div class="container">
        <nav class="top-footer-nav row">
          <div class="col-lg-6 col-md-3 col-12">
            <p class="google-title">Translate this page</p>
            <div id="google_translate_element"></div>
          </div>
          <div class="col-lg-2 col-md-3 col-12 mt-3 m-md-0">
            <ul class="list-group">
              <li class="list-group-item list-group-item-header">Find</li>
              <li class="list-group-item">
                <a href="https://mississauga.ca/publications/" target="_blank">
                  Publications
                </a>
              </li>
              <li class="list-group-item">
                <a
                  href="https://mississauga.ca/services-and-programs/pay-apply-report/"
                  target="_blank"
                >
                  Pay, apply, report
                </a>
              </li>
              <li class="list-group-item">
                <a
                  href="https://mississauga.ca/services-and-programs/services-a-to-z/"
                  target="_blank"
                >
                  Services A to Z
                </a>
              </li>
            </ul>
          </div>
          <div class="col-lg-2 col-md-3 col-12 mt-3 m-md-0">
            <ul class="list-group">
              <li class="list-group-item list-group-item-header">
                Get in touch
              </li>
              <li class="list-group-item">
                <a
                  href="https://mississauga.ca/home/contact-us/"
                  target="_blank"
                >
                  Contact Us
                </a>
              </li>
              <li class="list-group-item">
                <a
                  href="https://mississauga.ca/home/get-email-updates/"
                  target="_blank"
                >
                  Get email updates
                </a>
              </li>
            </ul>
          </div>
          <div class="col-lg-2 col-md-3 col-12 mt-3 m-md-0">
            <ul class="list-group">
              <li class="list-group-item list-group-item-header">Social</li>
              <li class="list-group-item">
                <a href="https://twitter.com/citymississauga" target="_blank">
                  <span class="fab fa-twitter"></span> 
                  Twitter
                </a>
              </li>
              <li class="list-group-item">
                <a
                  href="https://www.facebook.com/citymississauga"
                  target="_blank"
                >
                  <span class="fab fa-facebook"></span>
                  Facebook
                </a>
              </li>
              <li class="list-group-item">
                <a
                  href="https://www.linkedin.com/company/city-of-mississauga/"
                  target="_blank"
                >
                  <span class="fab fa-linkedin"></span>
                  LinkedIn
                </a>
              </li>
              <li class="list-group-item">
                <a
                  href="https://www.youtube.com/user/cityofmississauga"
                  target="_blank"
                >
                  <span class="fab fa-youtube"></span>
                  Youtube
                </a>
              </li>
              <li class="list-group-item">
                <a
                  href="https://www.instagram.com/citymississauga/"
                  target="_blank"
                >
                  <span class="fab fa-instagram"></span>
                  Instagram
                </a>
              </li>
            </ul>
          </div>
        </nav>
      </div>
      <div class="footer-border mt-md-5"></div>
      <div class="container">
        <nav class="bottom-footer-nav text-center">
          <div class="row">
            <div class="col-md-2 col-12 text-left">
              <p class="inline text-base">© City of Mississauga</p>
            </div>
            <div class="col-md-8 col-12 text-center">
              <ul class="list-inline">
                <li>
                  <a
                    href="https://mississauga.ca/home/privacy-and-terms/"
                    target="_blank"
                  >
                    Privacy and terms
                  </a>
                </li>
                <li><a>|</a></li>
                <li>
                  <a
                    href="https://mississauga.ca/home/accessibility/"
                    target="_blank"
                  >
                    Accessibility
                  </a>
                </li>
              </ul>
            </div>
            <div class="col-2"></div>
          </div>
        </nav>
      </div>
    </footer>
</template>

<script>
export default {
    name: "Footer",
    computed: {
        date() {
            return new Date().getFullYear().toString();
        }
    },
    mounted() {
        this.$nextTick(() => {
        let translateScriptTag = document.createElement("script");
        translateScriptTag.setAttribute(
            "src",
            "//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit"
        );
        document.head.appendChild(translateScriptTag);
        });
    }
};
</script>